import {
    FormControl,
    FormHelperText,
    MenuItem,
    Select,
    Typography,
    Box,
} from "@mui/material"
import PropTypes from "prop-types"
import React, {useMemo} from "react"
import {getOptions} from "../../misc/widget-functions"
import InfoIcon from "../../components/general/infoIcon"

export const widgetSelectPrototype = [
    {
        key: "infotext",
        type: "STRING",
        label: "infotext",
        size: 6,
    },
]

const SelectWidget = ({
    widget,
    value,
    onValueChange,
    disabled,
    triggerAction,
}) => {
    const options = useMemo(() => getOptions(widget), [widget])

    const onSelectChange = (event) => {
        const newValue = options.find(
            (option) => option.value === event.target.value,
        )

        if (onValueChange && newValue) {
            onValueChange(newValue.value)
        }
    }

    return (
        <FormControl fullWidth>
            {(widget.text || widget.infotext) && (
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}>
                    {widget.text && (
                        <Typography className={disabled ? "disabled" : ""}>
                            {widget.text}
                        </Typography>
                    )}

                    {widget.infotext && <InfoIcon infoText={widget.infotext} />}
                </Box>
            )}

            <Select
                id={widget.id}
                key={widget.id}
                value={value ?? ""}
                onChange={onSelectChange}
                className={widget.className}
                disabled={disabled}>
                {Array.isArray(options) &&
                    options.map((option) => (
                        <MenuItem
                            key={option?.id}
                            value={option.value}
                            disabled={option?.disabled}>
                            {option?.label}
                        </MenuItem>
                    ))}
            </Select>
            {widget.helperText && (
                <FormHelperText>{widget.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

SelectWidget.propTypes = {
    widget: PropTypes.object.isRequired,
    value: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
}

export default SelectWidget
